import React from "react";
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { Loading, withFocusable } from "../../services/visualLibraryService";
import { getPreferredLanguage } from "../../utils/perferedLanguage";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCodeWrapper,
  PinLoginInfoContainer,
  LineTextStyled,
  LoginOptionContainer,
  ButtonModalStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin } from "../../services/pinLoginService";
import { routes } from "../../routes";
import FreeLogo from "../../components/FreeLogo";
import { getGlobalButtonInfo } from "../../errors/globalButtons";
import { getWebPortalURL } from "../../services/tvodService";
import QRCodeReact from "react-qr-code";
import { autologin } from "../../services/authenticationService";
import { config } from "../../config/config";
import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import { getLoginRedirectionData } from "../../services/navigationService";
import { getSdk } from "../../services/sdkService";
import { eVoucherProvisioning } from "../../services/eVoucherEligibilityService";
import { getRedemptionSuccessTrackingData, trackEvent } from "../../services/analyticsService";
import { base64Encode, generateSignatureSHA512 } from "../../utils/encodingUtil";
import { isAnyAddonStatusActive } from "../../utils/subscriptionUtils";
import { getCurrentProfile, updateCurrentProfileInIndexDB } from "../../services/multipleProfilesService";
import { QRModal } from "../../services/modalsService";
import { getTwistMigrationUrl, isTwistMigrationEnabled } from "../../utils/twistUtils";
import { isUserAccountActive } from "../../services/accountStatusService";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";
const twistTvFocusPath = "twistTvModal_passThru";

const SIGNUP = "signup";
const PAGE = "signup";

const proceedToHomePath = "proceedToHomeButtonModalFocusPath";

function getGenericProvisioningError() {
  let text = `pages.voucherRedemption.errors.generic`;
  return {
    dismissable: false,
    modalText: i18n.get(text),
    buttons: [
      {
        label: i18n.get("pages.voucherRedemption.proceedToHomePage"),
        displayBlock: true,
        focusPath: proceedToHomePath,
        buttonHandler: () => {
          this.closeModal(false);
          redirectTo.call(this, routes.profileSelector, historyMethods.REPLACE);
        }
      },
      {
        label: i18n.get("pages.voucherRedemption.exitButton"),
        displayBlock: true,
        focusPath: "exitButtonModalFocusPath",
        buttonHandler: async () => {
          await getSdk();
          getSdk().systemManager.application.exit();
        }
      }
    ]
  };
}

function handleRequestError(error) {
  const { stateActions } = this.props;
  trackEvent(SIGNUP, "evoucher_redemption_error", error.message);
  stateActions.showGlobalModal(getGenericProvisioningError.call(this));
  this.props.setFocus(proceedToHomePath);
}

const INIT = "INIT";
class PinSignupPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null,
      showModal: false,
      isSamsungTV: false,
      linkTvURL: "",
      urlToShow: "",
      extraQueryParams: "",
      qrCodeURL: "",
      data: (this.props.location && this.props.location.state && this.props.location.state.data) || {},
      locale: localStorage.getItem("locale")
    };
    this.onBack = this.onBack.bind(this);
    this.pollingIntervalTime = 60000; // 60 secs
    this.pollingFinishTime = new Date(Date.now() + 6 * 60 * 1000);
    this.toggleQRCodeModal = this.toggleQRCodeModal.bind(this);
  }
  toggleQRCodeModal(modalShow) {
    this.setState({
      showQRModal: modalShow
    });
  }
  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
    return pinResponse.pin;
  }

  async redirectToPageWithLoggedInUser(loginPinResponse, locationReferer) {
    const { stateActions } = this.props;
    localStorage.setItem("credentials", loginPinResponse.webToken);
    const data = await autologin();
    const firstProfile = (data && data.profiles && data.profiles.length > 0 && data.profiles[0]) || null;
    firstProfile && (await updateCurrentProfileInIndexDB({ ...firstProfile, isGenerateJWTToken: true }));
    firstProfile && (this.props.applicationState.preferredLanguage = await getPreferredLanguage());
    if (localStorage && localStorage.locale) {
      data.locale = localStorage.locale;
      data.settings.language = localStorage.locale;
    }
    await stateActions.userLoggedIn(data);
    await stateActions.hideSettingsModal();
    redirectTo.call(this, locationReferer || routes.home, historyMethods.REPLACE);
  }

  async backUserWithUpdatedData(loginPinResponse) {
    let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
    const {
      stateActions,
      stateActions: { voucherData }
    } = this.props;
    const sdk = await getSdk();
    await sdk.mediaManager.clearLayoutCache();
    localStorage.setItem("credentials", loginPinResponse.webToken);
    const data = await autologin();
    if (voucherData) {
      const skipUserLangUpdate = true;
      stateActions.userLoggedIn(data, skipUserLangUpdate);
    } else stateActions.userLoggedIn(data);
    getAppState().userAccountStatus = data?.settings?.accountStatus;
    getAppState().userAddonStatus = isAnyAddonStatusActive(data?.settings?.addons);
    if ((voucherData && voucherData.autoRedeem) || getAppState().voucherData) {
      trackEvent("session_start", PAGE, "session_start", data);
      let path = await checkForUmanagedOrNonChangeableMop.call(this);
      if (path) {
        stateActions.setLocale(data.settings.language || data.locale);
        redirectTo.call(this, path, null, historyMethods.REPLACE);
      } else if (!path) {
        this.redeemVoucher();
      }
    } else {
      trackEvent("session_start", PAGE, "session_start", data);
      redirectTo.call(this, routes.profileSelector, { nextPageReference: redirectPath }, navigationMode);
    }
  }

  async pollingForTVODAssets(loginPinResponse, contentId, tvodAssetPollingIntervalTime) {
    const pollingFinishTime = new Date(Date.now() + 6 * 60 * 1000); // the next five minutes (6 number is because pollingFinishTime - 1)
    this.tvodTimer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > pollingFinishTime) {
          clearInterval(this.tvodTimer);
          await this.backUserWithUpdatedData.call(this, loginPinResponse);
        } else {
          let result = await getSdk().userManager.getTVODAssetsStatus({ contentId }, loginPinResponse.uid);
          if (result && result.length > 0 && result[0].status === INIT) {
            clearInterval(this.tvodTimer);
            await this.backUserWithUpdatedData.call(this, loginPinResponse);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, tvodAssetPollingIntervalTime);
  }

  async fromWelcomePageFlow(loginPinResponse, locationReferer) {
    const {
      stateActions: { showSettingsModal }
    } = this.props;
    const buttons = [
      {
        ...getGlobalButtonInfo("done"),
        buttonHandler: async () => await this.redirectToPageWithLoggedInUser(loginPinResponse, locationReferer)
      },
      {
        ...getGlobalButtonInfo("notNow"),
        buttonHandler: async () => await this.redirectToPageWithLoggedInUser(loginPinResponse, locationReferer)
      }
    ];
    showSettingsModal({
      modalTitle: i18n.get("pages.pinSignUp.modalHeading"),
      modalText: i18n.get("pages.pinSignUp.modalDescription"),
      isSignup: true,
      buttons
    });

    const pollingFinishTime = new Date(Date.now() + 6 * 60 * 1000); // the next five minutes (6 number is because pollingFinishTime - 1)
    this.signupTimer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > pollingFinishTime) {
          clearInterval(this.signupTimer);
          await this.redirectToPageWithLoggedInUser(loginPinResponse, locationReferer);
        } else {
          const result = await getSdk().userManager.get({
            avoidCache: true,
            avoidDeepCall: false,
            avoidDeepCallCache: true
          });
          if (result && result.settings && result.settings.addons && result.settings.addons.length > 0) {
            await this.redirectToPageWithLoggedInUser(loginPinResponse, locationReferer);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, this.pollingIntervalTime);
  }

  async componentDidMount() {
    this.props.onRef && this.props.onRef(this);
    const configuration = await config.request();
    const clientType = configuration.sdk.clientType;
    const { history } = this.props;
    const isFromWelcomePage =
      history.location && (history.location.referrer === "/welcome" || history.location.referrer === "/live")
        ? true
        : false;
    const locationReferer = history.location.referrer;
    const isFromPromotionsPage = history.location && history.location.referrer === "/promotions" ? true : false;
    const { contentId } = this.state.data;

    (async () => {
      await this.getPin().then(async pin => {
        const isLGTV = clientType === "lg-webos" ? true : false;
        const urlToShow =
          !isFromWelcomePage && !isFromPromotionsPage ? "auth" : isLGTV && isFromPromotionsPage ? "lgtv" : "linktv";
        const linkTvURL = "linktv";
        let extraQueryParams = isLGTV ? `&clientType=${clientType}` : "";
        // extraQueryParams += !isFromWelcomePage ? "&auth=true" : "";
        // if (!isFromWelcomePage && Object.keys(this.state.data).length !== 0) {
        //   const { contentTitle, contentOldPrice, contentNewPriceId, contentType } = this.state.data;

        //   const signature = {
        //     assetId: contentId,
        //     subscriptionType: contentType,
        //     priceProduct: contentNewPriceId
        //   };
        //   const hashedSignature = generateSignatureSHA512(signature);
        //   let urlQueryParams = `assetTitle=${contentTitle}&assetId=${contentId}&subscriptionType=${contentType}&priceProduct=${contentNewPriceId}&signature=${hashedSignature}`;
        //   urlQueryParams = contentOldPrice ? `${urlQueryParams}&oldPrice=${contentOldPrice}` : urlQueryParams;
        //   const encodedURLPart = base64Encode(urlQueryParams);

        //   extraQueryParams += `&return_url=/en/settings/tvodpayment?key=${encodedURLPart}`;
        // }

        const qrCodeURL = `${getWebPortalURL()}/${linkTvURL}?pin=${pin}${extraQueryParams}`;
        this.setState({
          isLoading: false,
          urlToShow,
          isLGTV,
          qrCodeURL,
          linkTvURL,
          pin,
          extraQueryParams
        });
      });

      this.timer = setInterval(async () => {
        try {
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            clearInterval(this.state.timer);
            clearInterval(this.timer);

            if (isFromWelcomePage) {
              this.fromWelcomePageFlow.call(this, loginPinResponse, locationReferer);
            }
            /** Fix Me: For now remove pooling for TVOD cases */
            // else if (Object.keys(this.state.data).length !== 0) {
            //   this.pollingForTVODAssets.call(this, loginPinResponse, contentId, tvodAssetPollingIntervalTime);
            // }
            else {
              await this.backUserWithUpdatedData.call(this, loginPinResponse);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }, 5000);
    })();
  }

  async redeemVoucher() {
    const { voucherData } = getAppState();
    const {
      history: { location },
      setFocus,
      stateActions
    } = this.props;
    try {
      this.setState({ isRedeeming: true });
      let baseCode = voucherData && voucherData.vouchers[0].code;
      let addonCode = undefined;
      this.setState({ isLoading: true });

      if (voucherData) {
        if (voucherData.status === "INVALID") {
          throw voucherData;
        }
        const vouchers = voucherData.vouchers.reduce((acc, val) => {
          if (val.subscriptions.includes("starzplay")) {
            acc.baseCode = val.code;
          } else {
            acc.addonCode = val.code;
          }
          return acc;
        }, {});

        baseCode = vouchers.baseCode;
        addonCode = vouchers.addonCode;
      }

      await eVoucherProvisioning(baseCode, addonCode);

      const userInfo = await getSdk().userManager.get({ avoidCache: true });
      stateActions.setLocale(userInfo.settings.language || userInfo.locale);
      trackEvent(SIGNUP, "evoucher_redemption_success", getRedemptionSuccessTrackingData.call(this));
      this.setState({ isRedeeming: false });
      localStorage.removeItem("voucherData");
      getAppState().currentProfileType = userInfo?.profileType;
      getAppState().userAccountStatus = userInfo.settings.accountStatus;
      getAppState().userAddonStatus = isAnyAddonStatusActive(userInfo?.settings?.addons);
      getAppState().addons = userInfo.settings.addons;
      getAppState().isActiveUser = userInfo.settings.accountStatus;
      getAppState().isSvodUser =
        isAnyAddonStatusActive(userInfo.settings?.addons) || isUserAccountActive(userInfo.settings.accountStatus)
          ? true
          : false;
      //getAppState().voucherData = null;

      redirectTo.call(
        this,
        routes.thankyou,
        location &&
          location.state &&
          location.state.fromSignup && {
            fromSignup: location.state.fromSignup
          },
        historyMethods.REPLACE
      );
    } catch (e) {
      const userInfo = await getSdk().userManager.get({ avoidCache: false });
      stateActions.setLocale(userInfo.settings.language || userInfo.locale);
      this.setState({ isLoading: false });
      this.setState({ isRedeeming: false });
      handleRequestError.call(this, e);
      setFocus(getGlobalButtonFocusPath("back"));
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.signupTimer) {
      clearInterval(this.signupTimer);
    }
    if (this.tvodTimer) {
      clearInterval(this.tvodTimer);
    }
    localStorage.removeItem("playerReferrer");
  }

  onBack() {
    if (this.state.showQRModal) {
      this.props.setFocus(twistTvFocusPath);
      this.props.stateActions.hideGlobalModal();
      this.toggleQRCodeModal(false);
      return true;
    }
    const { applicationState, location, history } = this.props;
    if (applicationState && applicationState.voucherData) {
      const path = location.referrer ?? routes.promotions;
      redirectTo.call(this, path, null, historyMethods.REPLACE);
      return true;
    }
    const hasHistoryState = !!(location && location.state);
    if (hasHistoryState && location.state && location.state.backDestination) {
      const backDestination = location.state && location.state.backDestination;
      const backDestinationPathname = backDestination.pathname || backDestination;
      history.replace(backDestinationPathname);
      return true;
    }
    redirectTo.call(
      this,
      location.state && location.state.pathName ? location.state.pathName : routes.home,
      null,
      historyMethods.REPLACE
    );
    return true;
  }
  closeModal(defaultFocusPath) {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
  }
  closeTwistModal() {
    this.toggleQRCodeModal(false);
    this.props.setFocus(twistTvFocusPath);
    this.props.stateActions.hideGlobalModal();
  }
  render() {
    const {} = this.props;
    const { pin, linkTvURL, urlToShow, extraQueryParams, locale } = this.state;
    if (!config) return null;

    return (
      <>
        <LandingPageStyled>
          {this.state.isLoading && <Loading overlay />}
          <PinLoginInfoContainer>
            <LeftBlock userLocale={locale}>
              <LandingContainerStyled>
                <TextStyled rank="1" text={i18n.get("pages.pinSignUp.heading")} size="large" />
                <StepContainer userLocale={locale}>
                  <StepNumber>1</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step1")} size="medium" />
                    <br />
                    <LinkStyled rank="2">{`starzplay.com/${urlToShow}`}</LinkStyled>
                  </StepTextContainer>
                </StepContainer>
                <StepContainer userLocale={locale}>
                  <StepNumber>2</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step2")} size="medium" />
                  </StepTextContainer>
                </StepContainer>
                <StepContainer userLocale={locale}>
                  <StepNumber>3</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step3")} size="medium" />
                    <PinContainerStyled userLocale={locale}>
                      {this.state.pin.split("").map((v, i) => (
                        <PinItemStyled userLocale={locale} key={`pin-${i}-${v}`} fontSize="xlarge" borderRadius="small">
                          {v}
                        </PinItemStyled>
                      ))}
                    </PinContainerStyled>
                  </StepTextContainer>
                </StepContainer>
              </LandingContainerStyled>
            </LeftBlock>
            <RightBlock userLocale={locale}>
              <AlignText>
                <LogoStyled>
                  <FreeLogo />
                </LogoStyled>
              </AlignText>
              <QRCodeWrapper>
                <QRCodeReact value={`${getWebPortalURL()}/${linkTvURL}?pin=${pin}${extraQueryParams}`} size={432} />
              </QRCodeWrapper>
            </RightBlock>
          </PinLoginInfoContainer>

          {isTwistMigrationEnabled() && (
            <LoginOptionContainer style={{ display: "flex", flexDirection: "column" }}>
              <LineTextStyled>{i18n.get("pages.pinLogin.or")}</LineTextStyled>

              <ButtonModalFocus
                label={i18n.get("pages.pinLogin.twistTV").toUpperCase()}
                focusPath={twistTvFocusPath}
                onEnterPress={() => {
                  this.toggleQRCodeModal(true);
                  trackEvent("mig_act_click", "", "mig_act_click");
                  QRModal.call(
                    this,
                    this.closeTwistModal.bind(this),
                    getTwistMigrationUrl(
                      `${getAppState().remoteConfig?.twist_to_sp_migration?.landing_page}?client_type=${
                        config.get().sdk.clientType
                      }`,
                      locale
                    ),
                    false
                  );
                }}
                size="medium"
                dataSnUp={""}
                dataSnDown={""}
                dataSnLeft={`@${joinFocusPath}`}
                dataSnRight={""}
                userLocale={locale}
              />
            </LoginOptionContainer>
          )}
        </LandingPageStyled>
      </>
    );
  }
}

export default withAppState(withSubtheme(PinSignupPage));
